import React from 'react';
import { Share, Plus, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface IOSInstallGuideProps {
  onClose: () => void;
}

export const IOSInstallGuide: React.FC<IOSInstallGuideProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/80 flex items-end justify-center animate-fade-in pb-[env(safe-area-inset-bottom)] overflow-y-auto overscroll-contain">
      <div className="bg-background rounded-t-3xl p-6 max-w-md w-full animate-slide-up border-t border-border">
        <div className="flex items-start justify-between mb-4">
          <h3 className="text-xl font-semibold text-foreground">
            Instalar en iPhone
          </h3>
          <button onClick={onClose} className="text-muted-foreground hover:text-foreground">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="space-y-4 mb-6">
          <div className="flex items-start gap-3">
            <div className="bg-primary/10 p-2 rounded-lg mt-1">
              <span className="text-lg font-bold text-primary">1</span>
            </div>
            <div className="flex-1">
              <p className="text-foreground font-medium mb-1">
                Toca el botón de compartir
              </p>
              <div className="flex items-center gap-2 text-muted-foreground text-sm">
                <Share className="w-4 h-4" />
                <span>(En la barra inferior de Safari)</span>
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="bg-primary/10 p-2 rounded-lg mt-1">
              <span className="text-lg font-bold text-primary">2</span>
            </div>
            <div className="flex-1">
              <p className="text-foreground font-medium mb-1">
                Selecciona "Agregar a pantalla de inicio"
              </p>
              <div className="flex items-center gap-2 text-muted-foreground text-sm">
                <Plus className="w-4 h-4" />
                <span>Desplázate hacia abajo en el menú</span>
              </div>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="bg-primary/10 p-2 rounded-lg mt-1">
              <span className="text-lg font-bold text-primary">3</span>
            </div>
            <div className="flex-1">
              <p className="text-foreground font-medium mb-1">
                ¡Listo! Ahora funciona offline
              </p>
              <p className="text-muted-foreground text-sm">
                Acceso directo desde tu pantalla de inicio
              </p>
            </div>
          </div>
        </div>

        <Button onClick={onClose} className="w-full">
          Entendido
        </Button>
      </div>
    </div>
  );
};
